import React from 'react';
import {Formik} from 'formik';
import {type FormikConfig, type FormikProps, type FormikValues} from 'formik/dist/types';
import {SetFieldValueContext} from 'src/components/util/form-components/EditorForm/SetFieldValueContext';
import { SubmittedContext } from '../EditorForm/SubmittedContext';
export type ResetFormFn = (nextState: any) => void;

export const AppFormik: typeof Formik = <Values extends FormikValues = FormikValues, ExtraProps = {}>(props: FormikConfig<Values> & ExtraProps) => {
  const {children, ...rest} = props;

  return (
    <Formik {...rest as any}>
      {(formikProps: FormikProps<Values>) => (
        <SubmittedContext.Provider value={formikProps.submitCount > 0}>
          <SetFieldValueContext.Provider value={formikProps.setFieldValue}>
            {children instanceof Function ?  children(formikProps) : children}
          </SetFieldValueContext.Provider>
        </SubmittedContext.Provider>
      )}
    </Formik>
  );
};
